import { Button } from '@kontentino/ui';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOpenBillingPage } from 'app/hooks/useBillingUrl';
import IntercomUtils from 'app/utils/intercom';

type Props = {
  primaryText: string;
};

const SubscriptionExpiredButtons: FC<Props> = ({ primaryText }) => {
  const navigate = useNavigate();
  const openBillingPage = useOpenBillingPage();

  // The v2 billing destination is an in-app route, so it must be reached via
  // client-side navigation (which respects the `/app` router basename).
  // A full-page `openUrl` to it lands outside the SPA basename and bounces back
  // to the dashboard — re-showing this modal in a dead-end (BUG-39). Legacy
  // accounts keep the full-page redirect to the v1 billing URL.
  const handleChoosePlan = () => openBillingPage('billing', { navigate });

  return (
    <>
      <Button
        onClick={handleChoosePlan}
        className="tw-w-full"
        data-cy="subscription-expired_choose-plan-button"
      >
        {primaryText}
      </Button>

      <div>
        or{' '}
        <span
          onClick={() =>
            IntercomUtils.newConversation('Hello! Just having a question')
          }
          className="tw-cursor-pointer tw-text-grayscale-100 tw-underline"
        >
          contact sales
        </span>
      </div>
    </>
  );
};

export default SubscriptionExpiredButtons;
